import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { FETCH_RANKING_POSITION } from './types';

export const triviaFetchRankingPositionActionThunk = () => async (dispatch, getState) => {
  try {
    const {
      trivia: { score },
    } = getState();
    await dispatch({ type: FETCH_RANKING_POSITION.REQUEST });

    const db = firebase.database();
    db.goOnline();
    const scoresSnapshot = await db.ref('/scores').orderByValue().once('value');

    if (scoresSnapshot.exists()) {
      const total = scoresSnapshot.numChildren();
      let ascPosition = -1;
      scoresSnapshot.forEach((item) => {
        ascPosition += 1;
        return score <= item.val();
      });

      const position = total - ascPosition;

      await dispatch({ type: FETCH_RANKING_POSITION.SUCCESS, payload: { position, total } });
    }
  } catch (err) {
    await dispatch({ type: FETCH_RANKING_POSITION.FAILURE, payload: err, error: true });
  } finally {
    disconnectDb();
  }
};
